import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { USER_SETTINGS_API } from '../../constants/central-api';
import { applicationJSONBodyBuilder } from '../../utils/body-builder';

export interface UserSettings {
  hide_webauthn_prompt?: boolean;
  chat_animation?: boolean;
  time_zone?: string;
  language_code?: string;
  data_export_format?: string;
  email_notification?: boolean;
  push_notification?: boolean;
  theme_mode?: string;
  auto_save_chat_history?: boolean;
  analytics_tracking?: boolean;
}

export interface UserSettingsResponse {
  success: boolean;
  data: UserSettings;
  message?: string;
}

export default async function get_user_settings_api_call(): Promise<UserSettings | null> {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: USER_SETTINGS_API,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_USER_SETTINGS';
  const customMsg = 'User Settings Fetched Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  if (!response?.success) {
    return null;
  }

  if (res.actionType === actionType && response.success === true) {
    return response.data || null;
  }

  return null;
}

export async function update_user_settings_api_call(
  settings: UserSettings
): Promise<boolean> {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const sendingData = {
    settings: settings,
  };

  const requestInfo: RequestInfo = {
    url: USER_SETTINGS_API,
    method: 'PUT',
    body: applicationJSONBodyBuilder(sendingData),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'UPDATE_USER_SETTINGS';
  const customMsg = 'User Settings Updated Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    true,
    false
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }

  if (res.actionType === actionType && response.success === true) {
    return true;
  }

  return false;
}
